import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderCentersByName',
  pure: true
})
export class OrderCentersByNamePipe implements PipeTransform {

  transform(input) {
    const keys = [];
    for (const key of input) {
      keys.push({ key: key[0], value: key[1] });
    }
    return keys.sort((a, b) => a.value.data.centerName.toLowerCase() > b.value.data.centerName.toLowerCase() ? 1 : -1);
  }

}
